<template>
<div>
  <div :class="{ 'mobile-spacer': isMobile }" />
  <div :class="{ 'mobile-container': isMobile }">
    <div
      v-if="isMobile"
      class="container-total-compra">
      <div>
        <strong :key="subTotal">
          Subtotal: {{ formatMoney(subTotal) }}
        </strong>
      </div>
    </div>
    <div
      v-if="!isMobile"
      class="d-flex flex-column justify-content-center align-items-center">
      <button
        class="btn"
        type="button"
        :disabled="disableNext"
        @click="next">
        <strong v-if="loading">
          <i class="fa-regular fa-hourglass" />
        </strong>
        <strong v-else>
          {{ isFinish ? 'Adicionar ao carrinho' : 'Próximo' }}
        </strong>
      </button>
      <button
        class="btn back mt-2"
        type="button"
        :style="{'visibility': disablePrevius ? 'hidden' : 'visible'}"
        :disabled="disablePrevius"
        @click="previus">
        <span>
          Voltar para a etapa anterior
        </span>
      </button>
    </div>
    <div
      v-else
      class="d-flex justify-content-between align-items-center"
      style="background-color: white;">
      <button
        class="btn"
        type="button"
        :style="{'visibility': disablePrevius ? 'hidden' : 'visible'}"
        :disabled="disablePrevius"
        @click="previus">
        <strong>
          Anterior
        </strong>
      </button>
      <button
        class="btn"
        type="button"
        :disabled="disableNext"
        @click="next">
        <strong v-if="loading">
          <i class="fa-regular fa-hourglass" />
        </strong>
        <strong v-else>
          {{ isFinish ? 'CONCLUIR' : 'Próximo' }}
        </strong>
      </button>
    </div>
  </div>
</div>
</template>

<script>

export default {
    components: {},
    props: {
        disablePrevius: {
            type: Boolean,
            default: () => false,
            required: true
        },
        disableNext: {
            type: Boolean,
            default: () => false,
            required: true
        },
        isFinish: {
            type: Boolean,
            default: () => false,
            required: false
        },
        loading: {
            type: Boolean,
            default: () => false,
            required: false
        },
        isMobile: {
            type: Boolean,
            default: () => false,
            required: false
        },
        moeda: {
            type: String,
            default: () => 'BRL',
            required: true
        },
        subTotal: {
            type: Number,
            default: () => 0,
            required: true
        },
    },
    emits: ['next', 'previus'],
    methods: {
        next() {
            this.$emit('next');
        },
        previus() {
            this.$emit('previus');
        },
        formatMoney(price) {
            let locale = 'pt-Br';

            if (this.moeda === 'USD') {
                locale = 'en-US';
            }

            if(price <= 0 || price === null) {
                return Number(0.00).toLocaleString(locale, { style: 'currency', currency: this.moeda });
            }
            return Number(price).toLocaleString(locale, { style: 'currency', currency: this.moeda });
        },
    }
};
</script>

<style scoped>
.btn {
    width: 100%;
    text-align: center;
    border: 0px;
    background-color: #E88A1D;
    border-radius: 4px;
    padding: 15px;
    color: white;
    cursor: pointer;
}
.btn[disabled] {
    cursor: default;
}

.btn.back {
    background-color: white;
    color: #464646;
}

.mobile-container {
  position: fixed;
  bottom: 10px;
  left: 0px;
  padding-left: 10px;
  padding-right: 10px;
  width: 100%;
  background-color: white;
}

.mobile-spacer {
  height: 150px;
  width: 100%;
}

.container-total-compra {
    width: calc(100% + 20px);
    margin-bottom: 5px;
    margin-left: -10px;
}
.container-total-compra>div {
    width: 100%;
    height: 40px;
    padding-left: 1rem;
    line-height: 17px;
    background-color: #FFF1E1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: start;
    border-top: 1px solid #E88A1D;
    border-bottom: 1px solid #E88A1D;
}

@media (max-width: 770px) {
    .btn {
        width: 49%;
    }
}
</style>
